import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

const Input = ({
	className,
	type,
	...props
}: React.ComponentProps<'input'>) => {
	return (
		<input
			data-slot="input"
			type={type}
			className={cn(
				'focus-cosy border-input bg-control-glass text-foreground placeholder:text-muted-foreground aria-[invalid]:border-input-invalid text-body-sm md:text-body-xs flex h-10 w-full rounded-xl border px-3 py-2 file:border-0 file:bg-transparent file:font-medium disabled:cursor-not-allowed disabled:opacity-50',
				className,
			)}
			{...props}
		/>
	)
}

export { Input }
